import { Injectable } from "@angular/core";
import { IID_OL_ACQUISITO_KO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { ProjectEntityStoreStrategy } from "../updateStoreStrategies";
import { IIDolAcquisitiKoQuery } from "./acquisitiKo.query";
import { IIDolAcquisitiKoStore } from "./acquisitiKo.store";
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.ACQUISIZIONE_NEGATIVA)
export class IIDolAcquisitiKoService extends CrudService<IID_OL_ACQUISITO_KO, IIDolAcquisitiKoStore, IIDolAcquisitiKoQuery> {
  constructor(
    protected store: IIDolAcquisitiKoStore,
    public query: IIDolAcquisitiKoQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_OL_ACQUISITO_KO,
      store,
      query,
      actionService,
      updateStrategy
    );
  }
}
